export default [
    {
        path: "/home",
        component: () => import("@/views/mainChartPage"),
        name: "home",
        meta: { title: "首页" },
    },
];
